<ng-container *ngIf="newBusiness">
  <app-invite-existing *transloco="let t">
    <app-main-header header>{{ t('new-business-acceptance') }}</app-main-header>
    <app-header isBig title>{{ t('invite-business')}}</app-header>
    <app-paragraph instructions>
      {{ t('invite-business-content-1', { newOrganization: newBusiness.businessName }) }}
      <span *ngIf="currentBusiness">
        {{ t('invite-business-content-1-current', { currentOrganization: currentBusiness.businessName }) }}
        <br><br>
        {{ t('invite-business-content-2') }}
        <br><br>
        {{ t('invite-business-content-3') }}
        <br><br>
        {{ t('invite-business-content-4', {currentOrganization: currentBusiness.businessName}) }}
        <br><br>
        {{ t('invite-business-content-5', {currentOrganization: currentBusiness.businessName}) }}
      </span>
    </app-paragraph>
    <span *ngIf="currentBusiness" question>
      {{ t('change-business-question') }}
    </span>
    <span *ngIf="!currentBusiness" question>
      {{ t('be-part-of-business-question', { organization: newBusiness.businessName }) }}
    </span>
    <div images>
      <app-business-change *ngIf="currentBusiness"
                           [currentBusiness]="currentBusiness"
                           [newBusiness]="newBusiness">
      </app-business-change>
      <app-rounded-image *ngIf="!currentBusiness"
                         [src]="newBusiness.imgSource"
                         [alt]="t('uploaded-image-alt')">
      </app-rounded-image>
    </div>
    <app-primary-button *ngIf="currentBusiness"
                        id="lnr-business-change-before"
                        stroked
                        wrapped
                        button
                        (clickAction)="refuseInvite()">
      {{ t('stay-business-answer') }}
    </app-primary-button>
    <app-primary-button *ngIf="currentBusiness"
                        id="lnr-business-change-after"
                        wrapped
                        button
                        (clickAction)="openAcceptInvitationDialog()">
      {{ t('change-business-answer') }}
    </app-primary-button>
    <app-primary-button *ngIf="!currentBusiness"
                        id="lnr-business-accept-invitation"
                        wrapped
                        button
                        (clickAction)="openAcceptInvitationDialog()">
      {{ t('be-part-of-business-answer', { organization: newBusiness.businessName }) }}
    </app-primary-button>
  </app-invite-existing>
</ng-container>
